export default "__VITE_ASSET__D0_RoH$T__"